<template>
  <aside
    v-if="visible"
    class="tc-update-banner"
    aria-label="Platform update"
  >
    <div class="tc-update-banner-inner">
      <p><strong>We’ve updated Test Candidates.</strong> A refreshed design, easier assessment creation and clearer candidate reports.</p>
      <button
        type="button"
        aria-label="Dismiss platform update"
        @click="dismiss"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </aside>
</template>
<script>
import { pickedApiRequest } from '@api/request'
const release = 'tc-platform-refresh-2026-09'
export default {
  data() { return { dismissed: false } },
  computed: {
    employer() { return this.$store.state.employers.employer },
    storageKey() { return this.employer ? `${release}:${this.employer.id}` : '' },
    visible() {
      // Accounts created through the new sign-up never saw the old design.
      return process.env.VUE_APP_SATELLITE === 'testcandidates' && this.employer && !this.dismissed &&
        !this.employer.signUpMethod &&
        this.employer.dismissedPlatformUpdate !== release &&
        // Home has its own What's new panel.
        this.$route.name !== 'home' &&
        !this.$route.matched.some(route => route.meta.hideShell || route.meta.assessment || route.meta.candidateWizard || route.meta.public)
    }
  },
  watch: {
    storageKey: {
      immediate: true,
      handler(key) {
        this.dismissed = false
        try { this.dismissed = !!key && localStorage.getItem(key) === 'dismissed' } catch (_) {}
        // Retry a dismissal that was made while offline, without redisplaying it.
        if (this.dismissed && this.employer.dismissedPlatformUpdate !== release) this.saveDismissal()
      }
    }
  },
  methods: {
    dismiss() {
      this.dismissed = true
      try { localStorage.setItem(this.storageKey, 'dismissed') } catch (_) {}
      this.saveDismissal()
    },
    async saveDismissal() {
      const employer = this.employer
      if (!employer) return
      try {
        await pickedApiRequest.post(`assessment/employers/${employer.id}/dismiss-platform-update`)
        if (this.employer && this.employer.id === employer.id) {
          this.$store.commit('employers/employer', { ...this.employer, dismissedPlatformUpdate: release })
        }
      } catch (_) { /* Keep it closed locally and retry on the next sign-in. */ }
    }
  }
}
</script>
<style scoped>
.tc-update-banner { background: #fff; border-bottom: 1px solid var(--tc-line, #e5e1db); color: var(--tc-ink, #18191d); }
.tc-update-banner-inner { max-width: 1440px; margin: 0 auto; padding: 14px 32px; display: grid; grid-template-columns: 36px minmax(0, 1fr) 36px; align-items: center; gap: 24px; }
p { grid-column: 2; text-align: center; margin: 0; font-size: 14px; line-height: 1.6; }
strong { color: var(--tc-navy, #1b1c40); margin-right: 6px; }
button { grid-column: 3; width: 36px; height: 36px; border-radius: 6px; font-size: 26px; line-height: 1; color: var(--tc-muted, #647087); }
button:hover { background: #f7f6f3; }
button:focus-visible { outline: 2px solid #78869b; outline-offset: 2px; }
@media (max-width: 640px) { .tc-update-banner-inner { padding: 12px 20px; gap: 12px; } strong { display: block; } }
</style>
